import { useBrandTheme } from "@/features/theme/hooks/useBrandTheme";
import type { BrandVouchersConfig } from "@/features/theme/types/brandTheme.type";

export const useVoucherThemeConfig = (): BrandVouchersConfig | null => {
  const { brandTheme } = useBrandTheme();
  return brandTheme?.vouchers ?? null;
};
